// Zeilen wie in den Tabellen bh_*. Beträge kommen als Euro aus der Datenbank, der Kern rechnet in Cent.

export const EINNAHME = "Betriebseinnahme";
export const FINANZAMT = "USt-Zahlung/-Erstattung Finanzamt";
export const PRIVAT = "Privat";
export const IGNORIEREN = "Ignorieren";
export const VERRECHNET = "Verrechnet (Rechnung/Stripe)";
export const GWG = "GWG bis 800 € netto";
export const BANKGEBUEHREN = "Bankgebühren";
export const FAHRZEUG = "Fahrzeug";
export const PAUSCHALEN = "Fahrt- und Homeoffice-Pauschalen";
export const AUSGABEN = [
  "Wareneinkauf",
  "Fremdleistungen",
  "Raum",
  FAHRZEUG,
  "Reise",
  "Telefon/Internet",
  "Werbung",
  "Büro/Software",
  "Versicherungen",
  BANKGEBUEHREN,
  GWG,
  "Sonstiges",
];
export const KATEGORIEN = [
  EINNAHME,
  ...AUSGABEN,
  FINANZAMT,
  PRIVAT,
  IGNORIEREN,
  VERRECHNET,
];

export type Besteuerung = "ist" | "soll";
export type Takt = "monatlich" | "vierteljaehrlich" | "befreit" | "offen";
export type Sonderfall = "13b" | "ige";
export type KontoArt = "geschaeftlich" | "privat";
export type Quelle = "import" | "hand" | "einlage" | "bar";
export type TagArt = "geschaeft" | "pendel" | "homeoffice";

export type Steuerjahr = {
  jahr: number;
  rechtsform: string;
  gewinnermittlung: string;
  besteuerung: Besteuerung;
  kur_verzicht: boolean;
  kur_verzicht_ab: string | null;
  dauerfrist: boolean;
  taetigkeitsbeginn: string | null;
  satz_regel: number;
  satz_ermaessigt: number;
  km_satz: number;
  pendel_satz: number;
  homeoffice_tag: number;
  homeoffice_max: number;
  anteil_telefon: number;
  anteil_kabel: number;
  entfernung_km: number;
  grenze_rechnung: number;
  grenze_gwg: number;
};

export type TaktZeile = {
  id?: number;
  jahr: number;
  gueltig_ab: string;
  takt: Takt;
};

export type Konto = {
  id: number;
  name: string;
  iban: string;
  art: KontoArt;
  von_jahr: number | null;
  bis_jahr: number | null;
};

export type Teil = { betrag: number; kategorie: string; satz: number };

export type Buchung = {
  id: number;
  konto_id: number | null;
  rechnung_id: number | null;
  quelle: Quelle;
  datum: string;
  betrag: number;
  partner: string;
  text: string;
  beleg: string | null;
  kategorie: string | null;
  satz: number | null;
  anteil: number;
  teile: Teil[] | null;
  sonderfall: Sonderfall | null;
};

export type Regel = {
  id: number;
  muster: string;
  kategorie: string;
  satz: number;
  unsicher: boolean;
  hinweis: string | null;
  sonderfall: Sonderfall | null;
};

export type Rechnung = {
  id: number;
  nummer: string;
  kunde: string;
  rechnungsdatum: string;
  leistungsdatum: string | null;
  brutto_19: number;
  brutto_7: number;
  brutto_0: number;
  status: "offen" | "bezahlt";
  bezahlt_am: string | null;
  notiz: string | null;
};

export type StripeUmsatz = {
  id: number;
  datum: string;
  beschreibung: string;
  brutto: number;
  gebuehr: number;
  satz: number;
  beleg: string | null;
};

export type Beleg = {
  id: number;
  richtung: "einnahme" | "ausgabe";
  pfad: string;
  dateiname: string;
  mime: string | null;
  datum: string | null;
  brutto: number | null;
  brutto_ermaessigt: number | null;
  partner: string;
  nummer: string | null;
  kategorie: string | null;
  satz: number | null;
  buchung_id: number | null;
  rechnung_id: number | null;
  pfad_xml?: string | null;
  hinweis?: string | null;
  email_id?: number | null;
  verworfen?: boolean;
  firma_id?: number | null;
};

export type Tag = {
  id: number;
  datum: string;
  art: TagArt;
  km: number | null;
  notiz: string | null;
};

export const JAHR_VORGABE = (jahr: number): Steuerjahr => ({
  jahr,
  rechtsform: "Einzelunternehmen",
  gewinnermittlung: "EÜR",
  besteuerung: "ist",
  kur_verzicht: true,
  kur_verzicht_ab: null,
  dauerfrist: false,
  taetigkeitsbeginn: null,
  satz_regel: 19,
  satz_ermaessigt: 7,
  km_satz: 0.3,
  pendel_satz: jahr <= 2025 ? 0.3 : 0.38,
  homeoffice_tag: 6,
  homeoffice_max: 1260,
  anteil_telefon: 50,
  anteil_kabel: 50,
  entfernung_km: 0,
  grenze_rechnung: 250,
  grenze_gwg: 800,
});

export const cent = (euro: number) => Math.round(euro * 100);
export const euro = (c: number) => c / 100;
